import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service to share highest number of price tags.
 */
@Injectable()
export class AccessoriesViewService {
  private numberOfProductTags: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  public numberOfProductTags$: Observable<number> =
    this.numberOfProductTags.asObservable();

  public setNumberOfAccessories(numberOfAccessories: number): void {
    this.numberOfProductTags.next(numberOfAccessories);
  }
}
